// extracted by mini-css-extract-plugin
module.exports = {"keyFeatures":"KeyFeatureCard_keyFeatures__1QHzm","keyDetial":"KeyFeatureCard_keyDetial__3zT27"};